angular.module('unergie.main')
.controller('cmsModalCtrl', ($scope, $uibModal, $uibModalInstance, ModalService, DataAccessMedias, CMS, AlertManager, ErrorCatcher, EnvUtils, contentId, versionId) => {
    $scope.refVersion = undefined
    $scope.versionSwitch = undefined
    $scope.version = { content: '' }

    $scope.EnvUtils = EnvUtils

    const computeRevisions = (content, vId) => {
        _.each(content.versions, (v) => {
            v.label = `${moment(v.updatedAt).format('DD/MM/YYYY HH:mm')}`
            if (content.prodVersion === v._id) {
                v.isProd = true
                v.label += ` - PRODUCTION`
            } else if (content.stagingVersion === v._id) {
                v.isStaging = true
                v.label += ` - STAGING`
            }
            if (vId && vId === v._id) {
                $scope.versionSwitch = v
            }
        })
    }

    const refresh = (v) => {
        return CMS.fetchContent({ id: contentId }).$promise.then((content) => {
            $scope.content = content
            if (v) {
                $scope.refVersion = _.find($scope.content.versions, { _id: v })
            } else if ($scope.content.prodVersion) {
                $scope.refVersion = _.find($scope.content.versions, { _id: $scope.content.prodVersion })
            } else {
                $scope.refVersion = _.orderBy($scope.content.versions, 'updatedAt').pop()
            }
            if ($scope.refVersion) {
                computeRevisions($scope.content, $scope.refVersion._id)
                $scope.version = _.clone($scope.refVersion)
            }
        })
    }

    refresh(versionId)

    $scope.isModified = () => {
        return $scope.refVersion && $scope.version && $scope.refVersion.content !== $scope.version.content
    }

    $scope.ckEditorOptions = {
        language: 'fr',
        allowedContent: true,
        entities: false,
        toolbarLocation: 'top',
        height: 500,
    }

    $scope.openMediaManager = function () {
        $uibModal.open({
            animation: true,
            templateUrl: '/states/mediaManager/mediaManager.html',
            controller: 'mediaManagerCtrl',
            windowClass: 'large-modal',
            backdrop: 'static',
            resolve: {
                images() {
                    return DataAccessMedias.getImages()
                },
            },
        })
    }

    $scope.stage = (version) => {
        $scope.staging = true
        return CMS.updateContent({ id: $scope.content._id }, { stagingVersion: version._id }).$promise.then((data) => {
            AlertManager.success('Version en staging')
            refresh(version._id)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.staging = false
        })
    }

    $scope.goLive = (version) => {
        $scope.goLiving = true
        return CMS.updateContent({ id: $scope.content._id }, { prodVersion: version._id }).$promise.then((data) => {
            AlertManager.success('Version en production')
            refresh(version._id)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.goLiving = false
        })
    }

    $scope.delete = (version) => {
        $scope.deleting = true
        return CMS.deleteContentVersion({ id: $scope.content._id, versionId: version._id }).$promise.then((data) => {
            AlertManager.success('Version supprimée')
            refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.deleting = false
        })
    }

    $scope.canSave = () => {
        return $scope.version._id && !$scope.version.isProd && $scope.isModified()
    }

    $scope.save = () => {
        $scope.saving = true
        return CMS.updateContentVersion({ id: $scope.content._id, versionId: $scope.version._id }, { content: $scope.version.content }).$promise.then((data) => {
            AlertManager.success('Révision mise à jour')
            refresh($scope.version._id)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    $scope.saveNew = () => {
        $scope.savingNew = true
        return CMS.addContentVersion({ id: $scope.content._id }, { content: $scope.version.content }).$promise.then((data) => {
            AlertManager.success('Nouvelle révision créée')
            $scope.content = data
            $scope.refVersion = _.last(data.versions)
            computeRevisions(data, $scope.refVersion._id)
            $scope.version = _.clone($scope.refVersion)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.savingNew = false
        })
    }

    $scope.switchVersion = () => {
        if ($scope.isModified()) {
            const r = confirm('Le contenu actuel a été modifié, êtes vous sûr de vouloir abandonner les modifications ?')
            if (r === true) {
                $scope.refVersion = $scope.versionSwitch
                $scope.version = _.clone($scope.refVersion)
            } else {
                $scope.versionSwitch = $scope.refVersion
            }
        } else {
            $scope.refVersion = $scope.versionSwitch
            $scope.version = _.clone($scope.refVersion)
        }
    }

    $scope.close = () => $uibModalInstance.close()
})
